var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMetricsNormalizedcutPerf = function SvgMetricsNormalizedcutPerf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.849 9.151 24 3 9.151 9.151 3 24l6.15 14.849L24 45l14.849-6.15L45 24zM32.4 35.914 24 29.813l-8.401 6.101 3.206-9.875-8.398-6.104 10.382-.002L24 10.06l3.21 9.873 10.382.002-8.398 6.104zM0 39h3v9H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 45h9v3H0zM45 0h3v9h-3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39 0h9v3h-9z"
  })));
};
export default SvgMetricsNormalizedcutPerf;